module.exports = function() {
  return new Worker(__webpack_public_path__ + "e09dc44db90962613d65.worker.js");
};